import { ReactNode } from 'react';
import { Grid } from '@mui/material';
import { styles } from './styles';

export const DraftCardMediaContainer = ({ children }: { children: ReactNode }) => {
  return <Grid sx={styles.container}>{children}</Grid>;
};
